import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.authService.loading$.pipe(
      // Wait until loading is DONE (false) before checking auth
      filter(loading => !loading),
      take(1),
      map(() => {
        const token = this.authService.getToken();
        const user = this.authService.getUser();

        if (!token || !user) {
          return this.router.createUrlTree(['/login']);
        }
        return true;
      })
    );
  }
}
